import { Task } from '@interfaces/ganttTasks/ganttTasks';

import { EGanttTaskType } from '@enums/ganttTasks';

export function removeHiddenTasks(tasks: Task[]) {
	const groupedTasks = tasks.filter(
		t => t.hideChildren && t.type === EGanttTaskType.milestone,
	);

	if (groupedTasks.length > 0) {
		const tasksToRemove = new Set<string>();

		for (const groupedTask of groupedTasks) {
			getChildren(tasks, groupedTask).forEach(id => tasksToRemove.add(id));
		}

		tasks = tasks.filter(t => !tasksToRemove.has(t.id));
	}

	return tasks;
}

function getChildren(taskList: Task[], task: Task) {
	const children = new Set<string>();

	taskList.forEach(t => {
		if (t.milestone === task.id) {
			children.add(t.id);
			getChildren(taskList, t).forEach(id => children.add(id));
		}
	});

	return children;
}

export const sortTasks = (taskA: Task, taskB: Task) => {
	const orderA = taskA.displayOrder || Number.MAX_VALUE;
	const orderB = taskB.displayOrder || Number.MAX_VALUE;

	if (orderA > orderB) {
		return 1;
	} else if (orderA < orderB) {
		return -1;
	}

	return 0;
};
